import type { EventObject } from '../eventTypes';
import type { TaskObject } from '../../tasks/types';

export interface CompleteTaskInput {
  id: string;
  etag: string;
  patch: Partial<TaskObject>;
}

/**
 * Build the updateObject input that marks a task-derived event's task done.
 *
 * `etag` falls back to '' when the source task carried neither `_etag` nor a
 * `version`; an empty If-Match may 412, which the caller recovers from by
 * invalidating the task query and letting the user retry against fresh data.
 */
export function buildCompleteTaskInput(event: EventObject): CompleteTaskInput | null {
  if (!event._sourceTaskId) return null;
  return { id: event._sourceTaskId, etag: event._sourceTaskEtag ?? '', patch: { status: 'done' } };
}
